import cx from "classnames";
import { useSelector } from "react-redux";

import * as colors from "../components/commonStyles/colors.module.css";
import { Programs } from "../models/programsConfig";
import { getCurrentProgram } from "../redux/selectors";

export const useProgramColorPicker = () => {
  const currentProgram = useSelector(getCurrentProgram);
  switch (currentProgram) {
    case Programs.Pitch:
      return colors.pitchPinkColor;
    case Programs.IdXbox:
    default:
      return colors.xboxGreenColor;
  }
};

export const getProgramBackgroundColorPicker = (program: Programs, includeHover?: boolean) => {
  switch (program) {
    case Programs.Pitch:
      return cx(
        colors.pitchPinkBackgroundColor,
        includeHover ? colors.pitchPinkHoverBackgroundColor : ""
      );
    case Programs.IdXbox:
    default:
      return cx(
        colors.xboxGreenBackgroundColor,
        includeHover ? colors.xboxGreenHoverBackgroundColor : ""
      );
  }
};

export const useProgramBackgroundColorPicker = (includeHover?: boolean) => {
  const currentProgram = useSelector(getCurrentProgram);
  return getProgramBackgroundColorPicker(currentProgram, includeHover);
};

export const useProgramFillColorPicker = () => {
  const currentProgram = useSelector(getCurrentProgram);
  switch (currentProgram) {
    case Programs.Pitch:
      return colors.pitchPinkFillColor;
    case Programs.IdXbox:
    default:
      return colors.xboxGreenFillColor;
  }
};
